import React, { useState } from 'react';
import styled from 'styled-components';

const TextContainer = styled.span`
  overflow: hidden;
  word-break: break-all;
`;

const Toggle = styled.span`
  color: ${({ theme }) => `${theme.colors.SECONDARY_MAIN}`};
  cursor: pointer;
  margin-top: 4px;
  font-size: 0.9em;
`;

const ViewMoreText = ({ text, maxChars = 50 }) => {
  const [expanded, setExpanded] = useState(false);

  const isLongText = text?.length > maxChars;
  const displayedText = expanded || !isLongText ? text : `${text?.slice(0, maxChars)}...`;

  return (
    <div>
      <TextContainer>{displayedText}</TextContainer>
      {isLongText && <Toggle onClick={() => setExpanded(!expanded)}>{expanded ? 'Show Less' : 'Show More'}</Toggle>}
    </div>
  );
};

export default ViewMoreText;
